import {Component} from 'panel';

import {registerMPElement} from '../../util/register-element';

import css from './index.styl?inline';
import template from './index.jade';

import '../tag';

const BACKSPACE_KEY = 8;
const MIN_INPUT_WIDTH = `12px`;

export default registerMPElement(
  `mp-tag-input`,
  class extends Component {
    static get attrsSchema() {
      return {
        ...super.attrsSchema,
        error: `boolean`,
        'min-tags': {type: `number`, default: 1},
        'search-text': {type: `string`, default: `Search`},
        tags: {
          type: `json`,
          default: [],
          description: `interface: TagItem[], with a label and optional isDisabled
        and attrs params (attrs gets passed down to the mp-tag attrs)`,
        },
        placeholder: `string`,
      };
    }

    get config() {
      return {
        defaultState: {
          inputText: ``,
          inputWidth: MIN_INPUT_WIDTH,
          tags: new Set(),
        },
        css,
        template,
        helpers: {
          canRemoveTag: (tag) => this.state.tags.size > this.attr(`min-tags`) && !tag.isDisabled,
          setInputText: (ev) => {
            this.update({inputText: ev.target.value});
            this._resizeInput();
            this.dispatchEvent(new CustomEvent(`change`, {detail: {value: this.state.inputText, action: `text`}}));
          },
          removeTag: (tagName) => this._removeTag(tagName),
          focusInput: () => this.focus(),
          handleKeyDown: (ev) => {
            if (ev.keyCode === BACKSPACE_KEY && this.state.inputText === ``) {
              const tagList = Array.from(this.state.tags);
              for (let i = tagList.length - 1; i >= 0; i--) {
                if (this.config.helpers.canRemoveTag(tagList[i])) {
                  this._removeTag(tagList[i]);
                  break;
                }
              }
            }
          },
          getPlaceholder: () => {
            if (this.state.showSearchIcon && this.attr(`search-text`)) {
              return this.attr(`search-text`);
            }
            return this.attr(`placeholder`) || ``;
          },
        },
        useShadowDom: true,
      };
    }

    attributeChangedCallback(attr) {
      super.attributeChangedCallback(...arguments);
      switch (attr) {
        case `tags`:
          this.update({tags: new Set(this.attr(`tags`)), inputText: ``});
          break;
      }
    }

    focus() {
      const searchInput = this.el.querySelector(`.mp-tag-input-search-input`);
      if (searchInput) {
        searchInput.focus();
      }
    }

    _resizeInput() {
      // make the search input width dynamic
      const span = document.createElement(`span`);
      span.className = `mp-tag-input-search-input-dummy`;
      span.innerText = this.el.querySelector(`.mp-tag-input-search-input`).value;
      this.el.appendChild(span);
      const buffer = 24;
      this.update({inputWidth: span.offsetWidth + buffer + `px`});
      this.el.removeChild(span);
    }

    _removeTag(tag) {
      const tags = this.state.tags;
      tags.delete(tag);
      this.update({tags});
      this.dispatchEvent(new CustomEvent(`change`, {detail: {tag, action: `removeTag`}}));
      requestAnimationFrame(() => this.focus());
    }

    _inputText(field, defaultText) {
      const inputText = this.attr(`input-text`);
      return inputText && inputText[field] ? inputText[field] : defaultText;
    }
  },
);
